<template>
  <div id="app">
    <template v-loading="loadingConfig || loadingAuth">
      <router-view
        @authenticated="setAuthenticated"
        v-if="!loadingConfig && !loadingAuth"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import storage from "@/components/utils/storage";
import authService from "@/services/auth.service";

export default {
  async created() {
    this.loadingConfig = true;
    await this.loadConfig();
    this.loadingConfig = false;

    this.loadingAuth = true;
    const isAuthenticated = await authService.initAuth();
    this.authenticated = isAuthenticated;
    this.loadingAuth = false;

    if (!isAuthenticated && !authService.isUsingOAuth2()) {
      this.$router.replace({ name: "login" });
    }
  },

  data() {
    return {
      loadingConfig: true,
      loadingAuth: false,
      authenticated: false,
    };
  },

  computed: {
    ...mapState("config", ["client"]),
  },

  methods: {
    ...mapActions("config", ["loadConfig"]),

    setAuthenticated: function (status) {
      this.authenticated = status;
      storage.saveAuthenticated(status);
    },

    logout: function () {
      authService.logout();
      this.authenticated = false;
    },
  },
  watch: {
    $route(to, from) {
      console.log("ROUTE CHANGE:", from.path, "->", to.path);
    },
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
}

.danger .el-input__inner {
  outline: none;
  border-color: #a22626;
  border-width: 2px;
}

.el-table th div,
.el-table th .cell,
.el-table th .cell .el-select .el-input.el-input--suffix {
  padding-left: 0;
  padding-right: 0;
}

.el-table th > .cell:active {
  border: 1px grey dashed;
}

.el-table th > .cell {
  border: 1px rgba(128, 128, 128, 0) dashed;
}

.el-table .caret-wrapper {
  margin: 4px 0;
}

.el-table th .el-date-editor .el-input__icon:first-child {
  margin-right: 4px;
}

.el-table th .el-date-editor .el-input__icon:last-child {
  margin-left: -7px;
}

.el-table-filter > .el-table__body-wrapper {
  display: none;
}

.el-table .el-table__row .cell {
  word-break: keep-all;
}

.side-menu .el-submenu__title {
  background-color: #222222;
  color: #c6c7c4;
}

.side-menu .el-submenu__title:hover {
  background-color: #3c3c3c;
}

.el-submenu .el-menu {
  background-color: #4c4c4c;
}

.el-submenu .el-menu-item {
  background-color: #4c4c4c;
  color: #888;
}

.el-submenu .el-menu-item:hover {
  background-color: #3c3c3c;
  color: #888;
}

.el-submenu .el-menu-item.is-active {
  background-color: #3c3c3c;
  color: #888;
}
</style>
